import { Base64Util } from '@kutil';
import { Product } from '../enums/product.enum';
import { Deserializable } from './deserializable.model';
import { JsonObject } from './json-object.model';
import { Serializable } from './serializable.model';

type AuthProviders = 'Google' | 'SignInWithApple' | 'kumanu' | 'other';

export enum SOCIAL_SSO {
  Google = 'Google',
  SignInWithApple = 'SignInWithApple',
}

export enum CORPORATE_SSO {
  kumanu = 'kumanu',
}

export enum NON_SSO_AUTH_PROVIDER {
  Cognito = 'Cognito',
  other = 'other',
}

export const SSO_PROVIDERS = [
  ...Object.keys(SOCIAL_SSO).map((key) => SOCIAL_SSO[key]),
  ...Object.keys(CORPORATE_SSO).map((key) => CORPORATE_SSO[key]),
];

export class AuthProviderState implements Deserializable<JsonObject, AuthProviderState>, Serializable<string> {
  constructor(
    public provider?: string,
    public token?: string,
    public id?: string,
    public product = Product.purposeful
  ) {}

  deserialize(input: JsonObject): AuthProviderState {
    if (input == null) {
      return null;
    }
    this.provider = input['provider'];
    this.token = input['token'];
    this.id = input['id'];
    this.product = input['product'];

    return this;
  }

  serialize(): string {
    return JSON.stringify({ provider: this.provider, token: this.token, id: this.id, product: this.product });
  }

  get asBase64() {
    return Base64Util.toWebSafe(Base64Util.encode(this.serialize()));
  }

  get urlEncoded() {
    return encodeURIComponent(this.serialize());
  }

  get urlEncodedBase64() {
    return encodeURIComponent(this.asBase64);
  }
}
